import React from 'react';
import Helmet from 'react-helmet';

export interface IJsonLdProps {
	data: { [k: string]: any } | { [k: string]: any }[];
}

// Escape "<" so a stray "<" (or "</script>") inside any string value cannot
// break out of the <script> element. Standard JSON-LD hardening.
const serialize = (data: IJsonLdProps['data']): string => JSON.stringify(data).replace(/</g, '\\u003c');

const JsonLd: React.FC<IJsonLdProps> = ({ data }) => (
	<Helmet>
		<script type="application/ld+json">{serialize(data)}</script>
	</Helmet>
);

export default JsonLd;
